import { render } from "./AllStamps.vue?vue&type=template&id=7a38a502&scoped=true"
import script from "./AllStamps.vue?vue&type=script&lang=js"
export * from "./AllStamps.vue?vue&type=script&lang=js"

import "./AllStamps.vue?vue&type=style&index=0&id=7a38a502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a38a502"]])

export default __exports__